"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const generateUniqueString_1 = __importDefault(require("../utils/generateUniqueString"));
const databaseFactory_1 = require("./databaseFactory");
const Relationizer_1 = __importDefault(require("./Relationizer"));
class Denormalizer extends Relationizer_1.default {
    constructor(path) {
        super(path);
        this.shouldClear = this.shouldClear.bind(this);
    }
    denormalize(bagId, entity, schema, db, options) {
        if (this.bag[bagId]) {
            return this.bag[bagId];
        }
        this.bag[bagId] = {};
        return Object.assign(this.bag[bagId], entity, schema.unfold(entity, db, this._run, options));
    }
    _run(db, idsToDenormalize, schemaId, options = { virtuals: true }) {
        const schema = this.getSchema(schemaId);
        if (idsToDenormalize == null || (typeof idsToDenormalize != 'string' && !Array.isArray(idsToDenormalize))) {
            if (typeof idsToDenormalize == 'object' && idsToDenormalize != null) {
                return this.denormalize((0, generateUniqueString_1.default)(), idsToDenormalize, schema, db, options);
            }
            return idsToDenormalize;
        }
        if (Array.isArray(idsToDenormalize)) {
            return idsToDenormalize.map(id => {
                if (id == null || (typeof id != 'string' && !Array.isArray(id))) {
                    if (typeof id == 'object' && id != null) {
                        return this.denormalize((0, generateUniqueString_1.default)(), id, schema, db, options);
                    }
                    return id;
                }
                return schema.unfold(id, db, this._run, options);
            });
        }
        return schema.unfold(idsToDenormalize, db, this._run, options);
    }
    shouldClear(db, schemaId, callId) {
        return this.getSchema(schemaId).shouldClear(db, this.shouldClear, callId);
    }
    run(collections, idsToDenormalize, schemaId, options) {
        this.db = (0, databaseFactory_1.databaseFactoryFromCollections)(collections, this.path);
        this.db.setCollections(collections);
        if (this.shouldClear(this.db, schemaId)) {
            this.bag = {};
        }
        return this._run(this.db, idsToDenormalize, schemaId, options);
    }
}
exports.default = Denormalizer;
